/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import costOverviewContainerStyle from "./costOverviewContainerStyle";
import { VAT } from "../../../services/globalVars";
import { Box, Typography } from "@mui/material";
import { DivorceFees, ValueInDispute } from "../../../types/CostCalculatorDivorce";

type CostOverviewContainerProps = {
  fees: DivorceFees;
  valueInDispute: ValueInDispute;
};

const CostOverviewContainer = ({ fees, valueInDispute }: CostOverviewContainerProps) => {
  const eur = (val: number) => {
    return val.toLocaleString("de-DE", { style: "currency", currency: "EUR" });
  };

  return (
    <>
      <Table sx={costOverviewContainerStyle.table}>
        <TableBody>
          <TableRow sx={costOverviewContainerStyle.tableRow}>
            <TableCell sx={costOverviewContainerStyle.tableCell}>
              <strong>Gegenstandswert der Scheidung</strong>
            </TableCell>
            <TableCell sx={costOverviewContainerStyle.tableCellValue} />
          </TableRow>
          <TableRow sx={costOverviewContainerStyle.tableRow}>
            <TableCell sx={costOverviewContainerStyle.tableCell}>Gegenstandswert Scheidungsverfahren</TableCell>
            <TableCell sx={costOverviewContainerStyle.tableCellValue}>{eur(valueInDispute.divorce)}</TableCell>
          </TableRow>
          <TableRow sx={costOverviewContainerStyle.tableRow}>
            <TableCell sx={costOverviewContainerStyle.tableCell}>Gegenstandswert Versorgungsausgleich</TableCell>
            <TableCell sx={costOverviewContainerStyle.tableCellValue}>{eur(valueInDispute.pensions)}</TableCell>
          </TableRow>
          <TableRow sx={costOverviewContainerStyle.tableRow}>
            <TableCell sx={{ ...costOverviewContainerStyle.tableCell, ...costOverviewContainerStyle.underlined }}>Gegenstandswert insgesamt</TableCell>
            <TableCell sx={{ ...costOverviewContainerStyle.tableCellValue, ...costOverviewContainerStyle.underlined }}>
              <strong>{eur(valueInDispute.total)}</strong>
            </TableCell>
          </TableRow>
          <TableRow sx={costOverviewContainerStyle.tableRow}>
            <TableCell sx={{ ...costOverviewContainerStyle.tableCell, ...costOverviewContainerStyle.tableCellHeader }}>
              <strong>Rechtsanwaltsgebühren inkl. MwSt {VAT * 100}%</strong>
            </TableCell>
            <TableCell sx={costOverviewContainerStyle.tableCellValue} />
          </TableRow>
          <TableRow sx={costOverviewContainerStyle.tableRow}>
            <TableCell sx={costOverviewContainerStyle.tableCell}>Verfahrensgebühr</TableCell>
            <TableCell sx={costOverviewContainerStyle.tableCellValue}>{eur(fees.lawyerCourt)}</TableCell>
          </TableRow>
          <TableRow sx={costOverviewContainerStyle.tableRow}>
            <TableCell sx={costOverviewContainerStyle.tableCell}>Auslagenpauschale</TableCell>
            <TableCell sx={costOverviewContainerStyle.tableCellValue}>{eur(fees.expenses)}</TableCell>
          </TableRow>
          <TableRow sx={costOverviewContainerStyle.tableRow}>
            <TableCell sx={costOverviewContainerStyle.tableCell}>Terminsgebühr</TableCell>
            <TableCell sx={costOverviewContainerStyle.tableCellValue}>{eur(fees.lawyerHearing)}</TableCell>
          </TableRow>
          <TableRow sx={costOverviewContainerStyle.tableRow}>
            <TableCell sx={{ ...costOverviewContainerStyle.tableCell, ...costOverviewContainerStyle.underlined }}>Rechtsanwaltsgebühren insgesamt</TableCell>
            <TableCell sx={{ ...costOverviewContainerStyle.tableCellValue, ...costOverviewContainerStyle.underlined }}>
              <strong>{eur(fees.lawyer)}</strong>
            </TableCell>
          </TableRow>
          <TableRow className="line">
            <TableCell sx={costOverviewContainerStyle.tableCell}>
              <strong>Gerichtskosten</strong>
            </TableCell>
            <TableCell sx={costOverviewContainerStyle.tableCellValue}>
              <strong>{eur(fees.court)}</strong>
            </TableCell>
          </TableRow>
          <TableRow sx={costOverviewContainerStyle.doubleUnderlinedRow}>
            <TableCell sx={costOverviewContainerStyle.doubleUnderlinedCell} />
            <TableCell sx={costOverviewContainerStyle.doubleUnderlinedCell} />
          </TableRow>
          <TableRow className="line">
            <TableCell sx={costOverviewContainerStyle.tableCell}>
              <Box component={"span"} sx={costOverviewContainerStyle.primary}>
                Scheidungskosten insgesamt
              </Box>
            </TableCell>i
            <TableCell sx={{ ...costOverviewContainerStyle.tableCellValue, ...costOverviewContainerStyle.total }}>{eur(fees.total)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Typography sx={costOverviewContainerStyle.disclaimer}>
        Diese Kostenberechnung ist lediglich eine grobe Schätzung. Die genauen Kosten ergeben sich erst nach der Angabe aller Daten. Maßgeblich ist allein der
        vom Gericht festgesetzte Wert.
      </Typography>
    </>
  );
};

export default CostOverviewContainer;
